import type { NodeMouseHandler } from '@xyflow/react';
import { useCallback, useMemo, useState } from 'react';

import { StructureCanvasHelper, type StructureEntityFlowNode } from '../canvas';
import type { Relation } from '../model';

// Hovering an entity lights up every line, label and chip it is part of.
function useRelationHighlight(relations: ReadonlyArray<Relation>) {
  const [hoveredEntityId, setHoveredEntityId] = useState<number>();

  const highlightedRelationIds = useMemo(
    () => StructureCanvasHelper.getRelationIdsOf(hoveredEntityId, relations),
    [hoveredEntityId, relations]
  );
  const handleNodeMouseEnter = useCallback<
    NodeMouseHandler<StructureEntityFlowNode>
  >((_event, node) => setHoveredEntityId(node.data.entity.id), []);
  const handleNodeMouseLeave = useCallback(
    () => setHoveredEntityId(undefined),
    []
  );

  return { highlightedRelationIds, handleNodeMouseEnter, handleNodeMouseLeave };
}

export { useRelationHighlight };
